import type { AmbassadorRecord, AmbassadorTier } from "@/lib/ambassadors/ambassadorEngine";

const TIER_GLOW: Record<AmbassadorTier, string> = {
  rookie: "#94a3b8",
  rising: "#22d3ee",
  featured: "#a855f7",
  legend: "#facc15",
};

const ROLE_EMOJI = {
  ambassador: "✨",
  national_captain: "🎖️",
  community_leader: "🛡️",
  creator_partner: "📣",
} as const;

export function AmbassadorBadge({ a, compact = false }: { a: AmbassadorRecord; compact?: boolean }) {
  const glow = TIER_GLOW[a.tier];
  return (
    <div
      className="inline-flex items-center gap-1.5 rounded-full border border-border/60 bg-background/70 px-2 py-1 text-[11px] font-bold"
      style={{ boxShadow: `0 0 0 1px ${glow}33, 0 8px 18px -10px ${glow}88` }}
      title={`${a.role.replace("_", " ")} · ${a.tier}`}
    >
      <span aria-hidden>{a.flag}</span>
      <span aria-hidden>{ROLE_EMOJI[a.role]}</span>
      {!compact && <span className="truncate max-w-[120px]">{a.handle}</span>}
      <span
        className="rounded-full px-1.5 py-0.5 text-[9px] uppercase tracking-wider"
        style={{ color: glow, background: `${glow}1a` }}
      >
        {a.tier}
      </span>
    </div>
  );
}
